import React, { useState } from "react";
import styles from "./startMeeting.module.scss";
// import meetnow from "../../../../styles/images/meetnow.svg";
// import joinnow from "../../../../styles/images/joinnow.svg";
// import eventsvg from "../../../../styles/images/eventsvg.svg";
import meetnow from "../../../../styles/images/landschedule.svg";
import joinnow from "../../../../styles/images/landjoin.svg";
import eventsvg from "../../../../styles/images/landcalender.svg";

import LetsMeetNow from "../popUp/letsMeetNow";
import JoinMeetingPopup from "../popUp/joinMeeting";
import { storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import { Dropdown, Menu } from "antd";
import { URCheckBox } from "../../../../shared/widgets/checkbox";
import { getMeetingId } from "../../../../base/meetingService/utils/meetingServices";
import { useHistory } from "react-router-dom";
type MeetingStartScreenState = {
  isMeetNow: boolean;
  isJoinMeet: boolean;
  isPersonalId : boolean;
  isAudio:boolean;
  isVideo:boolean;
};


export default function MeetingStartScreen() {
  const history = useHistory();
  const [getData, setData] = useState<MeetingStartScreenState>({
    isMeetNow:false,isJoinMeet:false,isPersonalId:false,isAudio:false,isVideo:true
  });

  
  const meetinNowPopupStatus = (action:boolean) => {
    setData({ ...getData, isMeetNow: action });
    
  };

  const joinMeetingPopstatus = (action:boolean) => {
    setData({ ...getData, isJoinMeet: action });
  };
  const checkMeetnow = (e:any,name:any)=>{
    setData({ ...getData, [name]: e.target.checked,isMeetNow:false });

  }
  let meetId:any = getMeetingId();
  const menu = (
    <Menu className="meetnows">
      <Menu.Item><URCheckBox onChange={(e: any) => checkMeetnow(e,'isPersonalId')} checked={getData.isPersonalId} >Start meeting with Personal Meeting ID {meetId}</URCheckBox></Menu.Item>
      <Menu.Item><URCheckBox onChange={(e: any) => checkMeetnow(e,'isVideo')} checked={getData.isVideo}>Start with Video</URCheckBox></Menu.Item>
      <Menu.Item><URCheckBox onChange={(e: any) => checkMeetnow(e,'isAudio')} checked={getData.isAudio}>Start with Audio</URCheckBox></Menu.Item>
    </Menu>
  );
  return (
    <>
      
      <div className={styles.meetingStartScreen}>
        <div className={styles.createNewList}>
          <div className={styles.tastList} >
            <div className={`${styles.boxSec} ${styles.meet}`} onClick={()=>meetinNowPopupStatus(true)}>
              <img src={meetnow} alt="" />
              {/* <span className={styles.textTitle}>Meet Now</span> */}
            </div>           
            <span className={styles.textDesc}>Meet Now
              <Dropdown overlay={menu} trigger={['click']} placement="bottom">
                <a onClick={e => e.preventDefault()}>
                  <span className="icon_down-arrow formeetnows landarrow"></span>
                </a>
              </Dropdown>
            </span>
          </div>
          <div className={styles.tastList} onClick={()=>joinMeetingPopstatus(true)}>
            <div className={`${styles.boxSec} ${styles.meetcenter}`}>
              <img src={joinnow} alt="" />
              {/* <span className={styles.textTitle}></span> */}
            </div>
            <span className={styles.textDesc}>Join Now</span>
          </div>
          <div className={styles.tastList} onClick={()=>storeWindowState('createMeeting',history)}>
            <div className={`${styles.boxSec} ${styles.meetlast}`}>
              <img src={eventsvg} alt="" />
              {/* <span className={styles.textTitle}></span> */}
            </div>
            <span className={styles.textDesc}>Schedule</span>
          </div>
        </div>
      </div>
      {getData.isJoinMeet && <JoinMeetingPopup joinMeetingStatus={ joinMeetingPopstatus }/>}
      {getData.isMeetNow && <LetsMeetNow leetsMeetNowStatus={ meetinNowPopupStatus } meetDetails={getData}/>}
  
    </>
  );
};

